import { render, staticRenderFns } from "./VagalManeuverAction.vue?vue&type=template&id=114b237e&scoped=true&"
import script from "./VagalManeuverAction.vue?vue&type=script&lang=js&"
export * from "./VagalManeuverAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114b237e",
  null
  
)

export default component.exports